import React, { useEffect, useState } from "react";
import ReactPDF, {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	PDFViewer,
	Font,
} from "@react-pdf/renderer";
import { useSearchParams } from "react-router-dom";
import funcionogramaService from "services/FuncionogramaService";
import userService from "services/UserService";
import organizationalStructureService from "services/OrganizationalStructureService";

import FontRobotoRegular from "../../../../assets/fonts/roboto/Roboto-Regular.ttf";
import FontRobotoBold from "../../../../assets/fonts/roboto/Roboto-Bold.ttf";
import FontRobotoItalic from "../../../../assets/fonts/roboto/Roboto-Italic.ttf";
import Loading from "components/Common/Loading";
import companyService from "services/CompanyService";

Font.register({
	family: "Roboto",
	fonts: [
		{ src: FontRobotoRegular },
		{ src: FontRobotoBold, fontWeight: "bold" },
		{ src: FontRobotoItalic, fontStyle: "italic" },
	],
});

const styles = StyleSheet.create({
	page: {
		padding: 30,
	},
	header: {
		fontSize: 20,
		fontFamily: "Roboto",
		fontWeight: "bold",
		textAlign: "center",
		marginBottom: 20,
	},
	title: {
		fontSize: 12,
		fontFamily: "Roboto",
	},
	titleBold: {
		fontSize: 12,
		fontFamily: "Roboto",
		fontWeight: "bold",
	},
	textDescription: {
		fontSize: 10,
		fontFamily: "Roboto",
	},
	section: {
		marginTop: 10,
	},
	space: {
		marginTop: 10,
	},
	separator: {
		borderBottomWidth: 1,
		borderBottomColor: "#000", // Cor da linha horizontal
		marginVertical: 10, // Margem vertical para separar os cargos
	},
});

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

function useWindowDimensions() {
	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions(),
	);

	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return windowDimensions;
}

const Infos = ({ company, item }) => (
	<Document>
		<Page size="A4" style={styles.page}>
			<Text style={styles.header}>Funcionograma</Text>

			<Text style={styles.title}>{company?.name}</Text>

			<Text style={styles.title}>
				Responsável:{" "}
				<Text style={styles.textDescription}>
					{item?.responsible_name || "Sem responsável"}
				</Text>
			</Text>
			{item?.jobs?.length > 0 ? (
				item.jobs.map((job, index) => (
					<View key={index}>
						{index < item.jobs.length && item.jobs.length > 1 && (
							<View style={styles.separator} />
						)}
						<Text style={styles.title}>
							Cargo:{" "}
							<Text style={styles.textDescription}>
								{job?.name || "Sem cargo"}
							</Text>
						</Text>

						{job?.job_roles?.length > 0 ? (
							<View style={styles.section}>
								<Text style={styles.titleBold}>
									Atividades:
								</Text>
								{job.job_roles.map((job_role, index) => (
									<Text
										key={index}
										style={styles.textDescription}
									>
										{index + 1} - {job_role.name}
									</Text>
								))}
							</View>
						) : (
							<Text style={styles.textDescription}>
								Sem atividades cadastradas
							</Text>
						)}

						<View style={styles.section}>
							<Text style={styles.titleBold}>Formação: </Text>
							<Text style={styles.textDescription}>
								{job?.formation || "Sem formações cadastradas"}
							</Text>
						</View>
						<View style={styles.section}>
							<Text style={styles.titleBold}>Conhecimento: </Text>
							<Text style={styles.textDescription}>
								{job?.knowledge ||
									"Sem conhecimentos cadastrados"}
							</Text>
						</View>
						<View style={styles.section}>
							<Text style={styles.titleBold}>Competência: </Text>
							<Text style={styles.textDescription}>
								{job?.competence ||
									"Sem competências cadastradas"}
							</Text>
						</View>
						<View style={styles.section}>
							<Text style={styles.titleBold}>Remuneração: </Text>
							<Text style={styles.textDescription}>
								{job?.remuneration ||
									"Sem remuneração cadastrada"}
							</Text>
						</View>
					</View>
				))
			) : (
				<Text style={styles.title}>
					Cargo: <Text style={styles.textDescription}>Sem cargo</Text>
				</Text>
			)}
		</Page>
	</Document>
);

const PrintPdf = () => {
	const { height } = useWindowDimensions();
	const [queryParameters] = useSearchParams();
	const cargoId = queryParameters.get("cargo_id");
	const moduleId = queryParameters.get("id");
	const [selectedAtividades, setSelectedAtividades] = useState([]);
	const [usuarios, setUsuarios] = useState([]);
	const [item, setItem] = useState({});
	const [company, setCompany] = useState(null);
	const [loading, setIsLoading] = useState(true);
	const company_id = localStorage.getItem("company_id");

	const getCompany = async () => {
		setCompany(await companyService.getById(company_id));
	};

	const getAll = async () => {
		await getCompany();
		if (moduleId) {
			await getItem();
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (company_id) {
			getAll();
		}
	}, [company_id]);

	async function getItem() {
		try {
			const response = await organizationalStructureService.getAllById(
				moduleId,
				cargoId,
			);
			setItem(response);
		} catch (error) {
			console.log(error);
		}
	}

	return (
		<>
			<Loading loading={loading} />
			{!loading && (
				<PDFViewer width="100%" height={height - 7}>
					<Infos
						companyItem={company}
						item={item}
						// atividades={selectedAtividades}
					/>
				</PDFViewer>
			)}
		</>
	);
};

export default PrintPdf;
